import { Code, Mail, Phone, MapPin, Linkedin, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate, useLocation } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToContact = () => {
    if (location.pathname === "/") {
      const contactElement = document.getElementById("contact");
      if (contactElement) {
        contactElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const contactElement = document.getElementById("contact");
        if (contactElement) {
          contactElement.scrollIntoView({
            behavior: "smooth"
          });
        }
      }, 100);
    }
  };
  const currentYear = new Date().getFullYear();
  const footerSections = [{
    title: "Services",
    links: [{
      name: "MVP Development",
      href: "/services/mvp-development"
    }, {
      name: "Custom Development",
      href: "/services/custom-development"
    }, {
      name: "Cloud Solutions",
      href: "/services/cloud-solutions"
    }, {
      name: "Data Visualisation",
      href: "/services/data-visualisation"
    }, {
      name: "Internships",
      href: "/internship"
    }]
  }, {
    title: "Company",
    links: [{
      name: "Home",
      href: "/"
    }, {
      name: "About Us",
      href: "/about"
    }, {
      name: "Products",
      href: "/our-work"
    }, {
      name: "Contact",
      href: "/#contact",
      onClick: true
    }]
  }];
  const socialLinks = [{
    icon: Linkedin,
    href: "https://www.linkedin.com/company/interesting-technologies/",
    label: "LinkedIn"
  }];
  return <footer className="bg-gradient-to-br from-black via-gray-900 to-blue-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-8 sm:mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <img src="/lovable-uploads/ITPL Logo.webp" alt="Interesting Technologies Logo" className="h-10 sm:h-12 w-auto" width="500" height="249" loading="lazy" />
            </div>

            <p className="text-gray-300 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-sm font-thin">
              Transforming businesses through innovative software solutions. We specialise in custom development
              and AI-integrated services that drive growth and efficiency.
            </p>

            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center gap-3 text-gray-300 text-sm sm:text-base">
                <Mail className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 flex-shrink-0" />
                <span>contact@interestech.com</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300 text-sm sm:text-base">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 flex-shrink-0" />
                <span>+(91) 88119-46161</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300 text-sm sm:text-base">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 flex-shrink-0" />
                <span>9AM to 6PM IST</span>
              </div>
              <div className="flex items-start gap-3 text-gray-300 text-sm sm:text-base">
                <MapPin className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span>3rd Floor, IT Bhavan, Indranagar, Agartala, West Tripura, Tripura 799006</span>
              </div>
            </div>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section, index) => <div key={index} className="min-w-0">
              <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-white">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => <li key={linkIndex}>
                    {link.onClick ? <button onClick={scrollToContact} className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-xs sm:text-sm block text-left py-2">
                        {link.name}
                      </button> : <Link to={link.href} className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-xs sm:text-sm block py-2">
                        {link.name}
                      </Link>}
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Newsletter Signup */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 mb-8 sm:mb-12 border border-white/10 rounded-3xl">
          <div className="text-center max-w-2xl mx-auto">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Stay Updated</h3>
            <p className="text-gray-300 mb-4 sm:mb-6 text-sm sm:text-base font-extralight">
              Get the latest insights on technology trends, software development, and AI innovations.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 max-w-md mx-auto">
              <input type="email" placeholder="Enter your email" className="flex-1 px-4 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base" />
              <Button className="bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 px-8 sm:px-10 font-semibold text-sm sm:text-base py-[14px] text-slate-50 h-12 w-full sm:w-auto min-w-[120px] sm:min-w-[140px]">
                Subscribe
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-300 text-xs sm:text-sm text-center md:text-left">
              © {currentYear} Interesting Technologies Private Limited. All rights reserved.
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
              {/* Social Links */}
              <div className="flex gap-3 sm:gap-4">
                {socialLinks.map((social, index) => <a key={index} target="_blank" href={social.href} aria-label={social.label} className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-200">
                    <social.icon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-300 hover:text-white" />
                  </a>)}
              </div>

              {/* Legal Links */}
              <div className="flex gap-4 sm:gap-6 text-xs sm:text-sm">
                <Link to="/privacy-policy" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Privacy Policy
                </Link>
                <Link to="/terms-of-service" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Terms of Service
                </Link>
                <Link to="/textmi/privacy-policy" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Textmi Privacy
                </Link>
                <Link to="/textmi/child-safety-standards" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Child Safety Standards
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;